import { Box, Chip, Tooltip } from '@mui/material';

const CONFIRMED_COLOR = '#03DAC6';
const SOFT_COLOR      = '#FFD740';
const TERM_COLOR      = '#CF6679';

const fmtDate = (str) => {
  if (!str) return '';
  if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
    const d = new Date(str + 'T00:00:00');
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
  return str;
};

const chipSx = (color, clickable) => ({
  height: 22,
  fontSize: '0.65rem',
  fontWeight: 700,
  bgcolor: `${color}22`,
  color,
  border: `1px solid ${color}55`,
  cursor: clickable ? 'pointer' : 'default',
  '&:hover': clickable ? { bgcolor: `${color}33` } : {},
});

/**
 * Uniform availability chip used across the entire app.
 *
 * Props:
 *   label      — display string, e.g. "Available Now" or "Available Dec 17"
 *   softEnd    — optional ISO date string; when present renders an amber "~Dec 17" chip
 *   tooltip    — optional hover text
 *   onClick    — optional click handler
 *   terminated — renders a red "Terminated" chip instead
 */
export default function AvailabilityChip({ label, softEnd, tooltip, onClick, terminated }) {
  if (terminated) {
    return (
      <Chip
        label="Terminated"
        size="small"
        sx={chipSx(TERM_COLOR, false)}
      />
    );
  }

  const softLabel = softEnd ? fmtDate(softEnd) : null;

  const inner = (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Chip
        label={label || 'Available'}
        size="small"
        onClick={onClick}
        sx={chipSx(CONFIRMED_COLOR, !!onClick)}
      />
      {softLabel && (
        <Chip
          label={`~${softLabel}`}
          size="small"
          sx={chipSx(SOFT_COLOR, false)}
        />
      )}
    </Box>
  );

  return tooltip ? (
    <Tooltip title={tooltip} placement="top">
      {inner}
    </Tooltip>
  ) : inner;
}
